import { IFetchAuthorizedOptions } from './types';

export default async function fetchApi({
  baseHostUrl,
  options,
}: {
  baseHostUrl: string;
  options: IFetchAuthorizedOptions;
}) {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...options?.headers,
  };

  const mergedOptions = {
    ...options,
    headers,
  };

  const url = baseHostUrl;

  return fetch(url, mergedOptions);
}
